export default __webpack_public_path__ + "static/media/medal.aa2e5050.svg";